module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgpubl",
    staticStyle: {
      "margin-bottom": "-2.2em"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "1",
      "src": "images/1.jpg"
    }
  })]), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e7339"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c18_r1#d6e2",
      "id": "d7e2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d7e7389"
    }
  }, [_c('i', [_vm._v("Do you see a man wise in his own eyes?")]), _c('br'), _c('i', [_vm._v("There is more hope for a fool than for him.")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("—Proverbs 26:12 ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e7539"
    }
  }, [_c('span', {
    staticClass: "dcap2",
    attrs: {
      "id": "d14e489"
    }
  }, [_vm._v("W")]), _vm._v("hat in the world qualifies me, not yet fifty, to write a book about wisdom? From the beginning, let me state clearly that wisdom is a journey and not a destination. On my journey—ahead of some, behind others—I have no illusions about having arrived. Wisdom is generally associated with gray hair, and though some gray is sprinkling in, I am still a relatively young man with much to learn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7869"
    }
  }, [_vm._v("This book was first published in 2007, and my wisdom journey has been enhanced by four years. I am glad for the opportunity to rerelease the book, and while the principles I presented in the first edition have been proven far longer than my brief five decades, I have updated numerous illustrations, statistics, and details. I’ve been richly blessed by feedback I’ve received virtually every week for four years from men and women and students who have read the book and applied various principles and ideas to their personal and professional lives.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e82410"
    }
  }, [_vm._v("The Hebrew word for wisdom means “skill in living,” which suggests that time—years—is required to achieve it. Even then, it takes more than time. As evangelist and elder statesman Billy Graham once said, “Knowledge is horizontal, but wisdom is vertical—it comes down from above.” In other words, God is the Source of all wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e84510"
    }
  }, [_vm._v("There is one reason I wrote this book, my first ever, and several reasons why I was comfortable doing so. If only one copy existed, it would be for my three children: Georgia, Mookie (his nickname since he was an infant), and Madison. If these words help them on their paths through life, it will be worth every hour of writing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e86610"
    }
  }, [_vm._v("Still, who am I to write on such a lofty subject? First, a friend once told me that “wisdom is caught, not taught.” If that’s true, I’ve had the good fortune to catch some wisdom through exposure to and association with people much wiser than me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e88410"
    }
  }, [_vm._v("Second, a career in public relations has heightened my regard for wisdom. To observe the power of public opinion, to have responsibility to respond to delicate media inquiries, to manage crises of every conceivable type, to participate in boardroom deliberations involving millions of dollars, thousands of employees, and the future of large organizations has taught me much about wisdom—and sometimes the lack of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e91711"
    }
  }, [_vm._v("In 1991, I founded a public relations firm called The DeMoss Group, and have been privileged to work closely with many of the world’s most prominent religious organizations—advising and helping them manage and fulfill their missions. The DeMoss Group has grown into a team of talented men and women, all of whom teach me, and I am in their debt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e94111"
    }
  }, [_vm._v("It seems every week I receive a phone call or e-mail that goes something like this: “Mark, I’m on the board of an organization in the midst of a major transition of leadership, and I’d like to get your advice on it.” Or, “Our event is going to be disrupted by protesters, and we want your counsel on how to handle it.” Or, “We’d like to get your thinking on a new initiative we’re planning to launch that may be controversial.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e96911"
    }
  }, [_vm._v("Now, I certainly have no lock on wisdom, but I’m a good listener (I’ve devoted a full chapter to listening) and a person can learn a lot by listening. This book is an attempt to share some of what I’ve learned.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e98311"
    }
  }, [_vm._v("Third, I’m a student of the greatest wisdom textbook of all time, the Old Testament book of Proverbs—written by King Solomon, who is still widely regarded as the wisest man who ever lived. (Another full chapter is devoted to the reading and studying of Proverbs.) For about half of my life I have read a chapter of Proverbs every single day—meaning I have been through the entire thirty-one-chapter book more than three hundred times.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e101612"
    }
  }, [_vm._v("Finally, and most important, the Bible contains a most wonderful promise from God: “If any of you lacks wisdom, let him ask of God, who gives to all liberally and without reproach, and it will be given to him” (James 1:5 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e103412"
    }
  }, [_vm._v("Solomon was the son of King David. One night God appeared to Solomon in a dream and told him that he could ask for and receive anything he wanted. That’s quite an offer—and Solomon’s answer is one of the Bible’s great stories. Basically handed a blank check, Solomon asked God for wisdom"), _c('i', [_vm._v("—for a discerning heart to know how to govern the people in his charge")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e106312"
    }
  }, [_vm._v("God’s reply tops even Solomon’s request. God said He would give Solomon what he asked for; but because he requested wisdom and not a long life or wealth, he would also receive what he did "), _c('i', [_vm._v("not")]), _vm._v(" ask for. And God showered Solomon with riches and honor unequaled among kings in his lifetime or since.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e108812"
    }
  }, [_vm._v("My prayer, my request of God for years, has been for wisdom—to handle relationships well, to manage a business and advise clients, to be a good husband and father. Most days I begin by asking God for wisdom; most meetings I enter silently asking God for His insight. God honors His promise to provide wisdom to all who ask, and amazingly, the offer never expires.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e111813"
    }
  }, [_vm._v("And so I offer my observations on wisdom in the pages that follow. I am not the source of wisdom and never will be; but I eagerly study wise people, and I’ve organized some of my thoughts, experiences, and observations into this small collection. Everything foundational in my personal and professional life is recorded in this book. Beyond my three children, I would be encouraged if any reader gleans an insight or two and applies it to more skillful living. Wisdom guides and guards us. It calls out to all who listen, offering its services. It speaks to men and women, boys and girls. Its advice is universal, timeless, and foolproof.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e115813"
    }
  }, [_vm._v("Meanwhile, the gaining of wisdom is amazingly simple. A reader of any age can apply almost any of these principles in a matter of minutes: read a Proverb every day, listen more than you speak, write more letters, tell the truth always. Wisdom does not favor intelligence or education, affluence or sophistication; it calls to everyone, everywhere. We need only respond.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176d01db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mark_9781595553966_epub_c19_r1.vue
// module id = 69
// module chunks = 0